<template>
    <div class="swiper-column swiper-main-container p-2">
        <div style="height: 150px;">
            <swiper
                class="swiper vehicle-carousel-top"
                :options="swiperOptionTop"
                >
                <swiper-slide
                    v-if="isMainBodyType(body)"
                    v-for="body in bodies"
                    :key="body.id"
                    >
                    <div
                        class="slide-wrapper d-flex justify-content-center position-relative text-center w-100 h-100 p-1"
                        :class="{ 'active': Number(filters.body_id) === body.id }"
                        @click="onSelectBody(body)"
                        @touchend="onSelectBody(body)"
                        >
                        <div class="m-auto w-100">
                            <img
                                class="body-type-image"
                                v-if="body.provider !== HOME_NET"
                                :src="`/images/car-type/${body.id === HEAVY_TRUCK_BODY_ID || body.id === CREW_CAB_BODY_ID ? 'Truck' : body.name}.png`"
                            >
                            <div class="text px-1 pt-3">
                                <label style="font-weight: 600;">
                                    {{ body.name }}
                                </label>
                                <div
                                    class="position-absolute badge badge-pill"
                                    style="top: 5px; right: 5px;"
                                    :style="{
                                        'background-color': filters.body_id === body.id
                                            ? '#ffffff'
                                            : '#15a9f0',
                                        'color': filters.body_id === body.id
                                            ? '#15a9f0'
                                            : '#ffffff',
                                    }"
                                    >
                                    <span>
                                        {{
                                            filters.dealership_listing_only
                                                ? body.in_company
                                                : body.not_sold
                                        }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </swiper-slide>
                <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
                <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
            </swiper>
        </div>
    </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import VehicleStatus from "@/constants/vehicle-statuses";
import VehicleMixin from '@/mixins/vehicle'
import { HOME_NET } from "@/constants/vehicle-providers";

const HEAVY_TRUCK_BODY_ID = 209;
const CREW_CAB_BODY_ID = 236;

export default {
    props: {
        modelValue: {
            type: [Number, String],
            default: () => (null),
        },
        bodies: {
            type: Array,
            default() {
                return [];
            }
        },
        filters: {
            type: Object,
            default() {
                return {};
            }
        },
        status: {
            type: [String, Number],
            default: VehicleStatus.AVAILABLE
        },
    },
    components: {
        Swiper,
        SwiperSlide
    },
    mixins: [VehicleMixin],
    data() {
        return {
            VehicleStatus,
            HOME_NET,
            HEAVY_TRUCK_BODY_ID,
            CREW_CAB_BODY_ID,
            swiperOptionTop: {
                spaceBetween: 15,
                slidesPerView: this.getSlidesPerView(),
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
            },
        }
    },
    methods: {
        onSelectBody(body) {
            this.$emit('showListingWithBody', body.id);
        },
        getSlidesPerView() {
            const screenWidth = window.innerWidth;
            if (screenWidth < 576) {
                return 1
            } else if (screenWidth < 992) {
                return 4
            }

            return 7
        },
    }
}
</script>
<style>
.vehicle-carousel-top .swiper-button-prev,
.vehicle-carousel-top .swiper-button-next {
    height: 30px;
    width: 30px;
    padding: 10px;
    background-color: #15a9f0;
    border-radius: 10px;
}
.vehicle-carousel-top .swiper-button-prev:after,
.vehicle-carousel-top .swiper-button-next:after {
    font-size: 16px;
}
.vehicle-carousel-top .slide-wrapper{
    border-radius: 4px;
    background-color: #f5f3f3;
    border: 1px solid #e5e5e5;
    cursor: pointer;
}
.vehicle-carousel-top .slide-wrapper:hover{
    background-color: #15a9f0 !important;
    color: #ffffff;
}
.vehicle-carousel-top .slide-wrapper.active {
    background-color: #15a9f0;
    border: 1px solid #15a9f0;
    color: #fff;
}
@media only screen and (max-width: 767px) {
    .body-type-image {
        width: 45%;
    }
}
@media only screen and (min-width: 768px) {
    .body-type-image {
        width: 80%;
    }
}
</style>
